import axios from "src/utils/axios";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  error: false,
  plans: [],
  currentPlan: null,
  step: 0,
  currentPaymentPlan: null,
  buingPlan: false,
};

const slice = createSlice({
  name: "plan",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getPlanSuccess(state, action) {
      state.plans = action.payload;
      state.isLoading = false;
    },

    setPaymentData(state, action) {
      state.currentPaymentPlan = action.payload;
    },

    setCurrentPlan(state, action) {
      state.currentPlan = action.payload;
    },

    getPlanSuccessById(state, action) {
      state.currentPlan = state.plans.find(
        (plan) => Number(plan.id) === Number(action.payload)
      );
      state.isLoading = false;
    },

    cleanPlan(state) {
      state.currentPlan = null;
      state.currentPaymentPlan = null;
    },

    deletePlan(state, action) {
      state.plans = state.plans.map((plan) =>
        plan.id === action.payload
          ? { ...plan, isActive: !plan.isActive }
          : plan
      );
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  setPaymentData,
  setCurrentPlan,
  getPlanSuccess,
  cleanPlan,
  getPlanSuccessById,
} = slice.actions;

// ----------------------------------------------------------------------

export function getPlans(onlyActive = true) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axios.get(`plan/read/${onlyActive}`);
      dispatch(slice.actions.getPlanSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deletePlan(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.deletePlan(id));
      await axios.delete(`/plan/delete/${id}`);
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// Toggle IsActive del plan — alias semántico de deletePlan, recomendado
// para nuevos botones de "Desactivar/Activar". Conserva Stripe Product.
export function togglePlanActive(id) {
  return async (dispatch) => {
    try {
      await axios.post(`/plan/toggleActive/${id}`);
      dispatch(getPlans(false));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// Eliminar plan PERMANENTEMENTE. Falla con 400 si tiene clientes activos
// o pagos asociados — propaga el error para que el caller muestre snackbar
// explicativo y el panel admin enseñe el guard al usuario.
export function deletePlanPermanently(id) {
  return async (dispatch) => {
    try {
      await axios.delete(`/plan/deletePermanently/${id}`);
      dispatch(getPlans(false));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}
export function createPlan(plan) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.post("/plan/create", plan);
      dispatch(getPlans(false));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function updatePlan(plan) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.put("/plan/update", plan);
      dispatch(getPlans(false));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
